module.exports = __webpack_public_path__ + "img/logo.eb660635.png";